import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Contact() {
  const { t } = useTranslation();
  const email = t('contact.email');
  const phone = t('contact.phone');

  return (
    <div style={{
      maxWidth: '560px',
      margin: '0 auto',
      padding: '2rem 1.5rem 4rem',
      background: 'var(--bg-base)',
      minHeight: '60vh',
    }}>
      <h1 style={{
        fontFamily: "'Bebas Neue', sans-serif",
        fontSize: '2.5rem',
        letterSpacing: '0.12em',
        color: '#ffffff',
        marginBottom: '1rem',
      }}>
        {t('contact.title')}
      </h1>
      <p style={{
        fontSize: '0.9rem',
        lineHeight: 1.7,
        color: 'var(--text-muted)',
        marginBottom: '2rem',
      }}>
        {t('contact.intro')}
      </p>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1.25rem',
      }}>
        <div>
          <p style={{
            fontFamily: "'Oswald', sans-serif",
            fontSize: '0.8rem',
            fontWeight: 600,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: 'var(--orange)',
            marginBottom: '0.35rem',
          }}>
            {t('auth.email')}
          </p>
          <a
            href={`mailto:${email}`}
            style={{
              fontSize: '1rem',
              color: '#ffffff',
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
            onMouseEnter={e => { e.target.style.color = 'var(--orange)'; }}
            onMouseLeave={e => { e.target.style.color = '#ffffff'; }}
          >
            {email}
          </a>
        </div>
        <div>
          <p style={{
            fontFamily: "'Oswald', sans-serif",
            fontSize: '0.8rem',
            fontWeight: 600,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: 'var(--orange)',
            marginBottom: '0.35rem',
          }}>
            {t('auth.phoneNumber')}
          </p>
          <a
            href={`tel:${phone.replace(/\s/g, '')}`}
            style={{
              fontSize: '1rem',
              color: '#ffffff',
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
            onMouseEnter={e => { e.target.style.color = 'var(--orange)'; }}
            onMouseLeave={e => { e.target.style.color = '#ffffff'; }}
          >
            {phone}
          </a>
        </div>
      </div>

      <p style={{
        marginTop: '2.5rem',
        fontSize: '0.85rem',
        color: 'var(--text-muted)',
      }}>
        <Link to="/privacy" style={{ color: 'var(--orange)', textDecoration: 'none', marginRight: '1rem' }}>
          {t('nav.privacy')}
        </Link>
        <span style={{ marginRight: '1rem' }}>·</span>
        <Link to="/terms" style={{ color: 'var(--orange)', textDecoration: 'none' }}>
          {t('nav.terms')}
        </Link>
      </p>

      <p style={{ marginTop: '1.5rem' }}>
        <Link
          to="/"
          style={{
            fontFamily: "'Oswald', sans-serif",
            fontSize: '0.85rem',
            fontWeight: 600,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: 'var(--orange)',
            textDecoration: 'none',
          }}
        >
          {t('contact.backToHome')}
        </Link>
      </p>
    </div>
  );
}
